export default {
  primary: '#1976d2',
  primaryDark: '#004ba0',
  primaryLight: '#63a4ff',
  secondary: '#757575',
  error: '#ef5350',
  accentColor: '#26a69a',
};

export const StatusColor = {
  pending: '#f39c12',
  processing: '#85c1e9',
  failed: '#e74c3c',
  completed: '#00cc81',
  cancelled: '#95a5a6',
};
